import { render } from "./UplImage.vue?vue&type=template&id=1992656a"
import script from "./UplImage.vue?vue&type=script&lang=js"
export * from "./UplImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__